import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {FileResponse} from '../../../../../models/file.response';
import {saveAs} from 'file-saver';
import {ActivatedRoute} from '@angular/router';
import {UploadInspectionReportComponent} from '../upload-inspection-report/upload-inspection-report.component';
import {APP_GUIDS, AppGuids} from '../../../../../app.guids';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {CoreService, DocumentService, ProleisObject, RequestParam} from "@proleis/proleis-rest-client";
import {LoadingService, NotificationService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-pm-position-list',
  templateUrl: './pm-position-list.component.html',
  styleUrls: ['./pm-position-list.component.scss'],
})
export class PmPositionListComponent implements OnInit {
  @Input() positions: ProleisObject[];
  @Output() posChangedEvent:EventEmitter<string> = new EventEmitter();

  displayedColumns: string[] = [
    'SNR',
    'PMDESCRIPTION',
    'PRICE',
    'PLANNING',
    'METROLOGIST',
    'APPOINTMENT',
    'DELIVERYDATE',
    'PROJECT',
    'PMGROUP',
    'INSPECTION_REPORT',
    'BUTTONS',
  ];
  dataSource: MatTableDataSource<ProleisObject>;

  constructor(
    private cs: CoreService,
    private ls: LoadingService,
    private ds: DocumentService,
    public ar: ActivatedRoute,
    private notificationService: NotificationService,
    @Inject(APP_GUIDS) private guids: AppGuids,
    private bs: MatBottomSheet,
  ) {}

  ngOnInit() {
    if (this.positions) {
      this.dataSource = new MatTableDataSource(this.positions);
    }
  }

  downloadReport(objectId: string, exportType: string) {
    const param: RequestParam = {
      DOCUEXPORT_TYPE: exportType,
      PATH_ID: '1474',
    };
    //SCRIPT_PBOPOS_PM_CREATE_DOCUEXPORT
    const actionId = '§0d1c24a2-2d39-11b2-8095-ab4c4d9dd252';
    this.ls.setBlocking('CREATING_DOC', true, 'Erstelle Dokument...');
    this.cs
      .executeAction<ProleisObject>(objectId, actionId, param)
      .subscribe((response) => {
        this.ls.setBlocking('CREATING_DOC', false, '');
        if (response) {
          this.ds.getDocumentFile(response.value).subscribe((response) => {
            const fileResponse: FileResponse =
              FileResponse.parseResponse(response);
            saveAs(fileResponse.content, fileResponse.fileName);
          });
        }
      });
  }

  uploadInspectionReport(objectId: string) {
    this.bs
      .open(UploadInspectionReportComponent)
      .afterDismissed()
      .subscribe((result) => {
        const formData: FormData = new FormData();
        formData.set('file', result.item(0), result.item(0).name);
        this.cs
          .executeActionFormData(
            objectId,
            '§' + this.guids.GUID_UPLOAD_INSPECTION_REPORT,
            formData,
            '1474'
          )
          .subscribe((result) => {
            this.notificationService.showNotification(
              'Prüfbericht hochgeladen',
            );
            this.posChangedEvent.emit();
          });
      });
  }
}
